<template>
  <div class="w-full items-center">
    <vs-popup

        title="7 keys to activating Sustainable behavioral change"
        :active.sync="sevenKeyDefualtPopup"
        :button-close-hidden="true"
        fullscreen
    >
      <p>where do you see yourself on this scale</p>
      <div class="vx-row mt-12">
        <div class=" vx-col lg:w-3/12 w-full items-center mt-4">
        </div>
        <div class=" vx-col lg:w-6/12 w-full  mt-4">
          <div style="
border: 1px solid #DFE3EB;
height: auto;
border-radius: 5px;">
            <div class="vx-row">
              <div class="vx-col lg:w-2/12">
                <img src="@/assets/images/sevenKeys/idea.png" style="height: 25px; " class="m-2">
              </div>
              <div class="vx-col lg:w-10/12">
                <h6 class="mt-2 ml-2">
                  <b> clarity</b>
                </h6>
                <p style="font-size: 10px;">I know how to make the change</p>
              </div>


            </div>
          </div>


        </div>
        <div class=" vx-col lg:w-3/12 w-full items-center mt-4">
        </div>
<!--        <div class=" vx-col lg:w-2/12 w-full">-->
<!--        </div>-->
      </div>
      <div class="vx-row">
        <div class=" vx-col lg:w-1/12 w-full items-center  mt-4">
        </div>
        <div class=" vx-col lg:w-4/12 w-full  mt-8 ">
          <div style="
border: 1px solid #DFE3EB;
height: auto;
border-radius: 5px;">
            <div class="vx-row">
              <div class="vx-col lg:w-2/12">
                <img src="@/assets/images/sevenKeys/presentation.png" style="height: 25px; " class="m-2">
              </div>
              <div class="vx-col lg:w-10/12">
                <h6 class="mt-2 ml-2">
                  <b> Perceived Benefit</b>
                </h6>
                <p style="font-size: 10px;">I believe the benefit is worth effort</p>
              </div>


            </div>
          </div>

        </div>
        <div class=" vx-col lg:w-2/12 w-full items-center  mt-4">
        </div>
        <div class=" vx-col lg:w-4/12 w-full  mt-8 ">
          <div style="
border: 1px solid #DFE3EB;
height: auto;
border-radius: 5px;">
            <div class="vx-row">
              <div class="vx-col lg:w-2/12">
                <img src="@/assets/images/sevenKeys/diagram.png" style="height: 25px; " class="m-2">
              </div>
              <div class="vx-col lg:w-10/12">
                <h6 class="mt-2 ml-2">
                  <b> Support</b>
                </h6>
                <p style="font-size: 10px;">I have the help I need</p>
              </div>


            </div>
          </div>

        </div>
        <div class=" vx-col lg:w-1/12 w-full items-center mt-4">
        </div>
<!--        <div class=" vx-col lg:w-2/12 w-full">-->
<!--        </div>-->
      </div>
      <div class="vx-row">

        <div class=" vx-col lg:w-4/12 ml-12 w-full  mt-8">
          <div style="
border: 1px solid #DFE3EB;
height: auto;
border-radius: 5px;">
            <div class="vx-row">
              <div class="vx-col lg:w-2/12">
                <img src="@/assets/images/sevenKeys/Vector.png" style="height: 25px; " class="m-2">
              </div>
              <div class="vx-col lg:w-10/12">
                <h6 class="mt-2 ml-2">
                  <b> Intent</b>
                </h6>
                <p style="font-size: 10px;">I know what I need to change</p>
              </div>


            </div>
          </div>


        </div>
        <div class=" vx-col lg:w-3/12 w-full mt-4">
        </div>
        <div class=" vx-col lg:w-4/12 w-full  mt-8 ml-12">
          <div style="
border: 1px solid #DFE3EB;
height: auto;
border-radius: 5px;">
            <div class="vx-row">
              <div class="vx-col lg:w-2/12">
                <img src="@/assets/images/sevenKeys/group-chat.png" style="height: 25px; " class="m-2">
              </div>
              <div class="vx-col lg:w-10/12">
                <h6 class="mt-2 ml-2">
                  <b> Feedback</b>
                </h6>
                <p style="font-size: 10px;">I know what is working and what isn’t</p>
              </div>


            </div>
          </div>
        </div>


<!--        <div class=" vx-col lg:w-2/12 w-full">-->
<!--        </div>-->
      </div>
      <div class="vx-row ">
        <div class=" vx-col lg:w-4/12 w-full  mt-8">
          <div style="
border: 1px solid #DFE3EB;
height: auto;
border-radius: 5px;">
            <div class="vx-row">
              <div class="vx-col lg:w-2/12">
                <img src="@/assets/images/sevenKeys/hearts.png" style="height: 25px; " class="m-2">
              </div>
              <div class="vx-col lg:w-10/12">
                <h6 class="mt-2 ml-2">
                  <b> Commitment</b>
                </h6>
                <p style="font-size: 10px;">I want to change</p>
              </div>


            </div>
          </div>

        </div>

        <div class=" vx-col lg:w-4/12 w-full mb-12 items-center">

          <img src="@/assets/images/sevenKeys/touch.png"  class="m-2">
        </div>
        <div class=" vx-col lg:w-4/12 w-full   mt-8">
          <div style="
border: 1px solid #DFE3EB;
height: auto;


border-radius: 5px;">
            <div class="vx-row">
              <div class="vx-col lg:w-2/12">
                <img src="@/assets/images/sevenKeys/thumbs-up.png" style="height: 25px; " class="m-2">
              </div>
              <div class="vx-col lg:w-10/12">
                <h6 class="mt-2 ml-2">
                  <b> Recognition</b>
                </h6>
                <p style="font-size: 10px;">I want to do more when other people react positively to the change</p>
              </div>


            </div>
          </div>

        </div>

<!--        <div class=" vx-col lg:w-2/12 w-full">-->
<!--        </div>-->
      </div>

    </vs-popup>
    <div class="w-full lg:w-2/3 md:w-2/3">
      <div class="add-skill-main">
        <h1 class="mb-2" v-if="traineeName">{{$t('coachLogin.trainee.addSkill')}}  {{traineeName}}</h1>
        <div v-if="addSkillStep === 1">

          <SelectCharacteristics
            v-if="$store.state.addSkill.searchCompetency === false"
            v-on:childToParent="onChildClick"
          />
          <SearchCompetency v-else-if="$store.state.addSkill.searchCompetency === true" />
        </div>

        <div v-if="addSkillStep > 1 && $store.state.addSkill.searchCompetency === true">
          <ProgressMeasure v-if="addSkillStep === 2" />
          <RateYourLevel v-else-if="addSkillStep === 3"/>
          <TrainingDuration v-else-if="addSkillStep === 4" />
          <ReviewSkill v-else-if="addSkillStep === 5" />
        </div>
        <div v-else>
          <SelectCompetency v-if="addSkillStep === 2" />
          <ProgressMeasure v-else-if="addSkillStep === 3" />
          <RateYourLevel v-else-if="addSkillStep === 4"/>
          <TrainingDuration v-else-if="addSkillStep === 5" />
          <ReviewSkill v-else-if="addSkillStep === 6" />
        </div>


        <!--<div v-show="addSkillStep === 6" class="mb-base" @click="addSkillStep = 1">
          <h6 class="text-center">
            <a href="#"><u>Edit my skill</u></a>
          </h6>
        </div>-->

        <div class="relative">
          <div
            v-show="addSkillStep > 1 || (addSkillStep === 1 && $store.state.addSkill.searchCompetency === true)"
            class="vx-col w-full footer-next"
          >
            <div class="vx-card vx-card-next">
              <div class="vx-card__collapsible-content vs-con-loading__container">
                <div class="vx-card__body">
                  <div class="vx-row">
                    <!-- BACK BUTTONS -->
                    <div class="vx-col mt-1 w-1/2 mb-2">
                      <div v-if="addSkillStep === 1">
                        <vs-button class="w-full add-skill-step-back" color="primary" type="border" @click="backToSelectCharacteristics">{{ $t("addNewSkill.ans1") }}</vs-button>
                      </div>
                      <div v-else>
                        <vs-button class="w-full add-skill-step-back" color="primary" type="border" @click="addSkillStep = addSkillStep - 1">{{ $t("addNewSkill.ans1") }}</vs-button>
                      </div>
                    </div>
                    
                    <!-- NEXT / SUBMIT BUTTONS -->
                    <div class="vx-col mt-1 w-1/2 mb-2">
                      
                      <div v-if="$store.state.addSkill.searchCompetency === true">
                        <vs-button v-if="addSkillStep < 5" class="w-full add-skill-step-back-next" color="primary" type="filled" :disabled="disabledNextButton" @click="addSkillStep = addSkillStep + 1">{{ $t("addNewSkill.ans2") }}</vs-button>

                        <!-- SUBMIT BUTTON (Step 5) -->
                        <vs-button
                          v-else-if="addSkillStep === 5"
                          class="w-full add-skill-step-back-next"
                          :class="{'opacity-50 cursor-not-allowed': !hasCoach}"
                          color="black"
                          type="filled"
                          @click="attemptSubmit"
                        >{{ $t("addNewSkill.ans3") }}</vs-button>
                      </div>
                      
                      <!-- IF NOT USING SEARCH COMPETENCY -->
                      <div v-else>
                        <vs-button v-if="addSkillStep < 6" class="w-full add-skill-step-back-next" color="primary" type="filled" :disabled="disabledNextButton" @click="addSkillStep = addSkillStep + 1">{{ $t("addNewSkill.ans2") }}</vs-button>

                        <!-- SUBMIT BUTTON (Step 6) -->
                        <vs-button
                          v-else-if="addSkillStep === 6"
                          class="w-full add-skill-step-back-next"
                          :class="{'opacity-50 cursor-not-allowed': !hasCoach}"
                          color="black"
                          type="filled"
                          @click="attemptSubmit"
                        >{{ $t("addNewSkill.ans3") }}</vs-button>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { library } from "@fortawesome/fontawesome-svg-core";
import { faPencilRuler } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import SelectCharacteristics from "./SelectCharacteristics";
import SelectCompetency from "./SelectCompetency";
import SearchCompetency from "./SearchCompetency";
import RateYourLevel from "./RateYourLevel";
import TrainingDuration from "./TrainingDuration";
import ProgressMeasure from "./ProgressMeasure";
import ReviewSkill from "./ReviewSkill";
import i18n from "@/i18n/i18n";

library.add(faPencilRuler);

export default {
  data() {
    return {
      addSkillStep: this.$store.state.addSkill.addSkillStep,
      searchCompetency: this.$store.state.addSkill.searchCompetency,
      userId:null,
      skillName:'',
      mentorName:'',
      playerName:'',
      sevenKeyDefualtPopup:false,
      CCD: this.$t("addNewSkill.data"),
      traineeName:'',
      hasCoach: true,
    };
  },
  watch: {
    // Watch for competency updates (especially from Search) and auto-resolve the parent characteristic
    '$store.state.addSkill.competency': {
      immediate: true,
      handler(newComp) {
        if (newComp && newComp.id && (!this.$store.state.addSkill.characteristic || !this.$store.state.addSkill.characteristic.id)) {
          for (let charId in this.CCD) {
            if (this.CCD[charId] && this.CCD[charId].competencies) {
              const comps = this.CCD[charId].competencies;
              
              // Check if the competency belongs to this characteristic
              if (comps[newComp.id] || (Array.isArray(comps) && comps.find(c => c.id === newComp.id))) {
                const payload = {
                  id: charId,
                  ...this.CCD[charId]
                };
                this.$store.dispatch("addSkill/addSelectedCharacteristic", payload).catch(err => {
                  console.log("Could not auto-set characteristic:", err);
                });
                break;
              }
            }
          }
        }
      }
    }
  },
  mounted() {
    // Enable double-click to proceed automatically across all steps
    window.addEventListener('dblclick', this.handleGlobalDblClick);
  },
  beforeDestroy() {
    window.removeEventListener('dblclick', this.handleGlobalDblClick);
  },
  components: {
    ReviewSkill,
    ProgressMeasure,
    TrainingDuration,
    RateYourLevel,
    SelectCompetency,
    SearchCompetency,
    SelectCharacteristics,
    FontAwesomeIcon
  },
  computed: {
    disabledNextButton() {
      // Characteristics
      if(this.addSkillStep === 1 && Object.keys(this.$store.state.addSkill.competency).length > 0) return false
      else if (
        this.addSkillStep === 1 &&
        (this.$store.state.addSkill.characteristic.length > 3 ||
          this.$store.state.addSkill.characteristic.length < 1)
      ) return true;
      else if (
        this.addSkillStep === 2 &&
        this.$store.state.addSkill.competency.length === 0
      ) return true;
      else if(this.addSkillStep === 3 && (this.$store.state.addSkill.progressMeasures.length === 0 && this.$store.state.addSkill.customProgressMeasures.length === 0)) return true;
      else if(this.addSkillStep === 4 && this.$store.state.addSkill.initialLevel == 0) return true;
      else if(this.addSkillStep === 5 && this.$store.state.addSkill.trainingDuration.length === 0) return true;
      else return false;
    }
  },
  created() {
    var url = new URL(window.location.href);

     this.userId = url.searchParams.get("userId");
     let traineeName = url.searchParams.get('traineeName')
     this.traineeName=traineeName;

     let localUser = JSON.parse(localStorage.getItem('userInfo'));
     const coachQuery = { traineeId: localUser.usersId };
     this.$store.dispatch("coachingExperience/fetchCoach", { query: coachQuery })
       .then(res => {
         if (res && res.data && res.data.length > 0 && res.data[0].coachId) {
           this.hasCoach = true;
         } else {
           this.hasCoach = false; 
         }
       })
       .catch(() => {
         this.hasCoach = false; 
       });

       this.$store
        .dispatch("trainee-competencies/find", {query: {usersId: this.userId}})
        .then(res => {
          console.log('data length ',res.data)
          if(res.data ===0) {
            this.sevenKeyDefualtPopup=true;
          }
        })
        .catch(err => {
          console.log("could not find trainee competencies", err);
        });

     if(this.userId){
       this.userId = url.searchParams.get("userId");
       this.$vs.notify({
         title: i18n.t('notification.user.addSkill.userId.success.a1',{ traineeName: traineeName }),
         fixed: false,
         color:'success'
       });
     }else{
       this.userId= this.$store.state.AppActiveUser.usersId;
     }
    this.$store.state.AppActiveUser.usersId
    // console.log('SuperCoachData',this.$store.state.AppActiveUser);
    // destroy/initialize all the state before beginning
    this.$store.dispatch("addSkill/destroyState").catch(err => console.log("could not destroy state", err));

    this.addSkillStep = this.$store.state.addSkill.addSkillStep;

    // this.sele
    // this.SelectCompetency=this.$route.query["competency_id"];
    // this.SelectCharacteristics=this.$route.query["characteristic_id"];
    console.log("characteristic id", this.$route.query["characteristic_id"]);
    console.log("competency id", this.$route.query["competency_id"]);
  },
  methods: {
     attemptSubmit() {
      if (!this.hasCoach) {
        // Show the toast warning
        this.$vs.notify({
          // 🔴 We inject the icon directly into the title HTML here 🔴
          title: '<div style="display: flex; align-items: center;"><i class="feather icon-alert-triangle" style="margin-right: 8px; font-size: 1.2rem;"></i> Action Required</div>',
          text: 'You cannot create the plan until Coach is assigned.',
          color: 'warning',
          position: 'bottom-right'
          // Notice we removed iconPack and icon from down here!
        });
        return; // Stop the code here so it doesn't crash
      }
      
      // If they DO have a coach, proceed normally
      this.saveUserSkill();
    },
    handleGlobalDblClick(e) {
      // Find if the double-click occurred on any selection card
      const card = e.target.closest('.vs-card, .vx-card, .framework-plan-card');
      
      // If double-clicking a framework card, let the single-click transition handle it (do not auto-advance)
      if (card && (card.classList.contains('framework-plan-card') || card.closest('.framework-plan-card'))) {
        return;
      }

      if (card) {
        // Trigger click on the primary "Next" button for all other standard cards
        const nextButton = document.querySelector('.add-skill-step-back-next, .footer-next button.vs-button-filled, button.vs-button-filled');
        if (nextButton && !nextButton.disabled) {
          nextButton.click();
        }
      }
    },
    backToSelectCharacteristics() {
      this.$store.dispatch("addSkill/searchCompetency", false).catch(err => {console.log("error search competency", err)})
    },
    onChildClick(value) {
      console.log("from child", value);
      this.addSkillStep = this.addSkillStep + 1;
    },
    saveUserSkill() {
      this.$vs.loading();

      // 1. SAFELY SET DEFAULT skillName (In case the CCD object lookup fails)
      this.skillName = this.$store.state.addSkill.competency.comp || 
                       this.$store.state.addSkill.competency.name || 
                       this.$store.state.addSkill.competency.title || 
                       "";

      const progress_measures_list = [];

      // 2. SAFELY parse progressMeasures without assuming the array format is perfect
      if (this.$store.state.addSkill.progressMeasures && this.$store.state.addSkill.progressMeasures.length > 0) {
        for (const pmIndex in this.$store.state.addSkill.progressMeasures) {
          const measure = this.$store.state.addSkill.progressMeasures[pmIndex];

          // Check if it's a string and has the expected "-" format before splitting
          if (typeof measure === 'string' && measure.includes("-")) {
            const s = measure.split("-");
            const charId = s[0];
            const compId = s[1];
            const pmsId = s[2];

            // SAFELY check if EVERY level of the CCD object exists before reading it!
            if (this.CCD && this.CCD[charId] && this.CCD[charId].competencies && this.CCD[charId].competencies[compId]) {
              
              // Extract skillName (matching your original logic)
              this.skillName = this.CCD[charId].competencies[compId].comp || this.skillName;

              // Check if the specific progress measure exists before pushing
              if (this.CCD[charId].competencies[compId].progressMeasures && this.CCD[charId].competencies[compId].progressMeasures[pmsId]) {
                progress_measures_list.push({
                  name: this.CCD[charId].competencies[compId].progressMeasures[pmsId].pm,
                });
              }
            }
          } else if (measure && measure.name) {
             // Fallback just in case progress measures are already passed as objects
             progress_measures_list.push({ name: measure.name });
          }
        }
      }

      // 3. Custom Progress Measures logic (unchanged)
      if(this.$store.state.addSkill.customProgressMeasures){
        for (const pm in JSON.parse(JSON.stringify(this.$store.state.addSkill.customProgressMeasures))) {
          progress_measures_list.push({
            name: this.$store.state.addSkill.customProgressMeasures[pm].cpm
          })
        }
      }

      // 4. API Calls (unchanged logic)
      let data= JSON.parse(localStorage.getItem('userInfo'));
      const query = {
        traineeId: data.usersId
      };
      
      this.$store
        .dispatch("coachingExperience/fetchCoach", { query })
        .then(res => {
          if (!res.data || res.data.length === 0 || !res.data[0].coachId) {
            this.$vs.loading.close();
            this.$vs.notify({
              title: 'Action Required',
              text: 'No coach assigned. Cannot submit plan.',
              color: 'danger'
            });
            return; // This stops the code and prevents the crash!
          }
          this.$store
            .dispatch("userManagement/fetchUsers", {query: {id:res.data[0].coachId, status: {
                  $ne:'deleted'
                }}})
            .then(getCoach => {
              this.mentorName=getCoach.data[0].firstName+' '+getCoach.data[0].lastName
            })
            .catch(err => {
              console.log("coach not found", err);
            });
            
          this.$store
            .dispatch("userManagement/fetchUsers", {query: {id:res.data[0].traineeId, status: {
                  $ne:'deleted'
                }}})
            .then(getTrainee => {
              this.playerName=getTrainee.data[0].firstName+' '+getTrainee.data[0].lastName
              const userNewSkill = {
                usersId: this.userId,
                competencyId: this.$store.state.addSkill.competency.id,
                initialLevel: this.$store.state.addSkill.initialLevel,
                trainingDuration: this.$store.state.addSkill.trainingDuration,
                start_date:new Date(),
                progress_measures:progress_measures_list,
                skill_name:this.skillName,
                mentorName:this.mentorName,
                playerName:this.playerName,
                progressMeasureIds: this.$store.state.addSkill.progressMeasures,
                customProgressMeasureIds: this.$store.state.addSkill.customProgressMeasures,
                progressStatus: "in_progress"
              };

              this.$store
                .dispatch("addSkill/saveUserSkill", userNewSkill)
                .then(res => {
                  console.log("New Skill Created", res);
                  const allProgressMeasures = userNewSkill.progressMeasureIds.concat(userNewSkill.customProgressMeasureIds);
                  const l = allProgressMeasures.length;
                  let c = 0;
                  
                  if (l === 0) { // Safety check in case no measures exist at all
                      this.$vs.loading.close();
                      this.$router.push({
                        name: "skill-details",
                        params: { traineeCompetenciesId: res.id }
                      });
                      return;
                  }

                  for (const pms in allProgressMeasures) {
                    let pm = {}
                    if(allProgressMeasures[pms].id !== undefined) {
                      pm = {
                        traineeCompetenciesId: res.id,
                        progressMeasureId: allProgressMeasures[pms].id,
                        progressMeasure: allProgressMeasures[pms].cpm
                      };
                    } else {
                      pm = {
                        traineeCompetenciesId: res.id,
                        progressMeasureId: allProgressMeasures[pms]
                      };
                    }
                    this.$store
                      .dispatch("addSkill/saveUserSkillPrgms", pm)
                      .then(res1 => {
                        if (l === ++c) {
                          this.$vs.loading.close();
                          this.$router.push({
                            name: "skill-details",
                            params: { traineeCompetenciesId: res.id }
                          });
                        }
                      })
                      .catch(err1 => {
                        console.log("error", err1);
                      });
                  }
                })
                .catch(err => {
                    console.log("Skill could not be created", err);
                    this.$vs.loading.close();
                });
            })
            .catch(err => {
              console.log("trainee not found", err);
              this.$vs.loading.close();
            });
        })
        .catch(err => {
          console.log("coach not found", err);
          this.$vs.loading.close();
        });
    }
  },
  destroyed () {}
};
</script>

<style scoped>
.justify-content-center {
  justify-content: center;
}

@media (max-width: 767px) {
  .footer-next {
    position: fixed;
    bottom: 0;
    /*width: 100%;*/
    width: 100vw;
    left: calc(-50vw + 50%);
  }
}

.vx-card-next {
  margin-top: 2rem;
  box-shadow: none;
  -webkit-box-shadow: none;
}

.add-skill-main {
  margin-bottom: 5rem;
}
.con-vs-popup.fullscreen .vs-popup {
  width: 50%;
  height: 50%;
}

.items-center {
  text-align: center;
  text-align: -moz-center;
  text-align: -webkit-center;
}
</style>
